// extracted by mini-css-extract-plugin
export var blink = "styles-module--blink--V44mt";
export var c_flexibleTextBlock = "styles-module--c_flexibleTextBlock--uBQ6v";
export var content = "styles-module--content--x6vRS";
export var ctas = "styles-module--ctas---8F+Z";
export var description = "styles-module--description--E8ZgY";
export var pretitle = "styles-module--pretitle--kvJzs";
export var textContent = "styles-module--textContent--1lqYi";
export var title = "styles-module--title--5yA3m";